import { React, Component } from 'utils';

export default class Point extends Component {

	handleClick() {
		var { onSelect, index } = this.props;
		onSelect(index);
	}

	render() {
		var { className } = this.props;
		return <span onClick={ () => { this.handleClick() } } className={ className }></span>
	}

}


// WEBPACK FOOTER //
// ./src/modules/components/point.js